/** Refresh customer credentials on widget exit without indefinitely holding reconciliation. */
export async function refreshHostedConnection(provider) {
    let timer;
    const timeout = new Promise((resolve) => {
        timer = setTimeout(() => resolve(false), 10000);
    });
    try {
        return await Promise.race([
            provider.getConnection().then((connection) => connection.ok),
            timeout,
        ]);
    }
    catch {
        return false;
    }
    finally {
        clearTimeout(timer);
    }
}
